import { combineReducers } from "redux";
import userReducer from "../modules/user/store/reducer";

const reducer = combineReducers({
    user: userReducer,
})

export default reducer;

export type RootState = ReturnType<typeof reducer>;